module.exports={
    "xxs": "0",
    "xs": "375",
    "s": "576",
    "m": "768",
    "l": "1024",
    "xl": "1366",
    "xxl": "1920"
  }
